import React from "react";
import HeaderTopic from "../../partials/HeaderTopic";
import BasicButtons from "../../partials/BasicButtons";
import FooterMenu from "../../partials/FooterMenu";
import { getCitysCourts } from '../../api/getCitysCourts';
import { addNewMatchToRound } from '../../api/addNewMatchToRound';
import * as func from "../../utils/funcs";
import { useHistory, useParams } from "react-router-dom";

import styles from "./AddMatch.module.css";

function AddMatch(props) {
  const { user, league, teams, rounds, refreshStates } = props;
  const { leagueId, roundId } = useParams();
  const history = useHistory();

  const [courts, setCourts] = React.useState([]);

  const [group1, setGroup1] = React.useState("");
  const [group2, setGroup2] = React.useState("");
  const [court, setCourt] = React.useState("");
  const [time, setTime] = React.useState("00:00:00.00");

  const [textError, setTextError] = React.useState("");

  React.useEffect(() => {
    let mounted = true;

    getCitysCourts(league.city).then((data) => {
      mounted && setCourts(data);
    });

    return function cleanup() {
      mounted = false;
    };
  }, [league]);


  const handleSubmit = async () => {
    if (group1 === "") {
      setTextError("לא בחרת קבוצה 1");
    } else if (group2 === "") {
      setTextError("לא בחרת קבוצה 2");
    } else if (group1 === group2) {
      setTextError("בחרת את אותה הקבוצה פעמיים");
    } else if (court === "") {
      setTextError("לא בחרת מגרש");
    } else if (time === "00:00:00.00") {
       setTextError("לא בחרת זמן למשחק");
     } else {
       setTextError("");
        const res = await addNewMatchToRound(
         parseInt(leagueId, 10),
         parseInt(roundId, 10),
         group1,
         group2,
         func.makeDateFromTime(func.getRound(roundId, rounds).round_date, time),
         court
       );
       if (!res.error) {
        history.push(`/leagues/${leagueId}/rounds/${roundId}`);
      }
    }
  };

  return (
    <div className={styles.addMatch}>
      <HeaderTopic topic={"ליגת " + league.name} />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <FooterMenu setActive="vs" />

      <h2 className="sectionTitleSize">יצירת משחק חדש</h2>
      <h4>
        מחזור {func.getRound(roundId, rounds).round_number} -{" "}
        {func.showDate(func.getRound(roundId, rounds).round_date)}
      </h4>

      <form>
        <select
          value={group1}
          onChange={(e) => {
            setGroup1(e.target.value);
          }}
        >
          <option value="" hidden>
            קבוצה
          </option>
          {teams.map((group) => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <select
          value={group2}
          onChange={(e) => {
            setGroup2(e.target.value);
          }}
        >
          <option value="" hidden>
            קבוצה
          </option>
          {teams.map((group) => (
            <option key={group.id} value={group.id}>
              {group.name}
            </option>
          ))}
        </select>

        <select
          value={court}
          onChange={(e) => {
            setCourt(e.target.value);
          }}
        >
          <option value="" hidden>
            בחירת מגרש
          </option>
          {courts &&
            courts.map((court1) => (
              <option value={court1.id} key={court1.id}>
                {court1.name}
              </option>
            ))}
        </select>

        <input
          type="time"
          value={time}
          onChange={(e) => {
            setTime(e.target.value);
          }}
        />

        <span className={styles.errorMsg}>{textError}</span>

        <button type="button" className="btnLarge" onClick={handleSubmit}>
          יצירת משחק
        </button>
      </form>
    </div>
  );
}

export default AddMatch;
